import { put, call, take, fork } from 'redux-saga/effects'
import { updateCollectionCollaboratorService } from '../../api/collection'
import { updateCollectionCollaboratorSuccess } from '../../reducers/collection/action'
import { UPDATE_COLLECTION_COLLABORATOR } from '../../reducers/collection/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* updateCollectionCollaboratorFlow(payload) {
  try {
    const { id, userId, data, callback } = payload
    yield call(updateCollectionCollaboratorService, id, userId, data)
    yield put(updateCollectionCollaboratorSuccess(userId, data))
    yield put(operationSuccess())

    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* updateCollectionCollaboratorWatcher() {
  while (true) {
    const action = yield take(UPDATE_COLLECTION_COLLABORATOR)
    const { payload } = action

    yield fork(generalSaga, updateCollectionCollaboratorFlow, payload)
  }
}
